module.exports = __webpack_public_path__ + "media/src/img/ok-icon-ee9e0a19d546cbdc54e68b7719996c34.svg";